// src/hooks/useNeededPatches.js
import { useEffect } from 'react';
import { keyForPatch } from '../utils/dateHelpers';

const NEEDED_PATCH_KEY = 'planner:neededPatches';

/**
 * Czyta patche needed z localStorage
 */
export function readNeededPatches() {
    try {
        return JSON.parse(localStorage.getItem(NEEDED_PATCH_KEY) || '[]') || [];
    } catch {
        return [];
    }
}

/**
 * Zapisuje patche needed do localStorage
 */
export function writeNeededPatches(arr) {
    try {
        localStorage.setItem(NEEDED_PATCH_KEY, JSON.stringify(arr));
    } catch { }
}

/**
 * Hook do zarządzania needed patches dla danego dnia
 */
export function useNeededPatches(date, callUpdateNeeded) {
    useEffect(() => {
        const applyForThisRow = (patches) => {
            patches.forEach((p) => {
                if (p.date !== date) return;
                callUpdateNeeded(p.date, p.eventName, p.needed, p.calendarId, p.gId);
            });
        };

        // 1) zastosuj z LS (jeśli są dla tego dnia)
        const arr = readNeededPatches();
        const toApplyNow = [];
        const keep = [];
        arr.forEach(p => (p.date === date ? toApplyNow.push(p) : keep.push(p)));
        if (toApplyNow.length) {
            applyForThisRow(toApplyNow);
            writeNeededPatches(keep);
        }

        // 2) nasłuchuj eventów „na żywo"
        const onPatch = (e) => {
            const p = e.detail;
            if (!p || p.date !== date) return;
            callUpdateNeeded(p.date, p.eventName, p.needed, p.calendarId, p.gId);
        };
        window.addEventListener('planner:applyNeededPatch', onPatch);
        return () => window.removeEventListener('planner:applyNeededPatch', onPatch);
    }, [date, callUpdateNeeded]);

    return { readNeededPatches, writeNeededPatches, keyForPatch };
}

